'use client'

import React from 'react'
import { cn } from '@kiao-voice/ui-kit'
import { revealDelay, useReveal } from '../../lib/use-reveal'

/**
 * 進場的 class。元件自己掛 `useReveal()` ref 時（示範卡就是這樣，它的 ref 另有
 * 用途）直接借用這一串，不要再抄一份。
 */
export const REVEAL_CLASS =
  'translate-y-[18px] opacity-0 transition-[opacity,transform] duration-700 [transition-delay:var(--rd,0ms)] data-[in]:translate-y-0 data-[in]:opacity-100 motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:transition-none'

export interface RevealProps {
  /** 包裝元素。預設 div；需要 <li>／<p> 的語意時換掉。 */
  as?: React.ElementType
  /** 階梯延遲（--rd）。同一排的第二、三項各晚一點進場。 */
  delayMs?: number
  className?: string
  children: React.ReactNode
}

/**
 * 捲動進場。`useReveal()` 進場時標的是 `data-in` **attribute** 而不是 class：
 * React 每次 render 都會整串重寫 className，imperative 加上去的 class 會被洗掉，
 * 而 React 不會動它沒 render 的 attribute。
 *
 * `prefers-reduced-motion` 下直接顯示（`motion-reduce:` 那組把初始狀態蓋回去），
 * 所以 IntersectionObserver 沒跑到的元素也不會永遠留在 opacity-0。
 */
export function Reveal({ as: Component = 'div', delayMs, className, children }: RevealProps) {
  const reveal = useReveal()
  return (
    <Component
      ref={reveal}
      style={delayMs === undefined ? undefined : revealDelay(delayMs)}
      className={cn(REVEAL_CLASS, className)}
    >
      {children}
    </Component>
  )
}
